<template>
  <div class="trainingPilihJadwal">
    <SOSlotBase :container-name="`trainingPilihJadwal`" :loading="isLoading">
      <template v-slot:title-bar>
        <SOTitleBar :page-title="title" :type="'back'" @back="back" />
      </template>

      <template v-slot:content>
        <div class="bg p-x-20 p-y-12 d-flex">
          <div class="d-block">
            <div class="f-semi f-14">
              Pilih tanggal yang tertera dibawah untuk menentukan jadwal
              training
            </div>
          </div>
        </div>

        <Calendar
          @changedate="(v) => changeDate(v)"
          :id_jenis="idJenis"
          :idx="sesi"
        ></Calendar>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import Calendar from "../components/Calendar";
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "TrainingPilihJadwal",
  components: {
    SOSlotBase,
    SOTitleBar,
    Calendar,
  },
  data() {
    return {
      isButtonDisabled: true,
      isLoading: false,
      idJenis: "",
      sesi: this.$route.params.sesi,
    };
  },
  async mounted() {
    await this.init();
  },
  computed: {
    ...mapGetters(moduleName, {
      detailJenisTraining: "detailJenisTraining",
      formJadwal: "formJadwal",
    }),

    title() {
      return this.idJenis === "paid_online"
        ? "Pilih Jadwal Ke " + this.sesi
        : "Pilih Jadwal";
    },
  },
  methods: {
    ...mapActions({
      getDetailJenisTraining: `${moduleName}/getDetailJenisTraining`,
    }),
    back() {
      this.$router.go(-1);
    },
    changeDate(v) {
      console.log(v);
      if (v) {
        this.isButtonDisabled = false;
      } else {
        this.isButtonDisabled = true;
      }
    },
    async init() {
      let params_idJenis = this.$route.params.idjenis;
      this.idJenis = params_idJenis;
    },
  },
};
</script>
<style scoped>
.trainingPilihJadwal .separator {
  width: unset;
}
.bg {
  background-color: #f2f5f7;
  color: #6f7287;
  padding: 20px;
  display: flex;
  padding: 12px 20px;
  align-items: center;
  flex: 1 0 0;
}

.btnlnjt {
  margin-top: 4rem;
  background-color: #206cff;
  color: white;
}
.btn.btn-long.btnlnjt:disabled {
  background-color: #ccc;
  color: #f6f6f6;
  cursor: not-allowed;
}
.jadwal-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
}
</style>
